<app-menu>
<div class="coaching-page" [class.light-theme]="!isDark">
  <main class="coaching-shell">
    <header class="page-header">
      <div>
        <div class="eyebrow">Admin Tools / PAUL</div>
        <h1>PAUL Coaching Data</h1>
        <p>Every admin chat, evaluation case, technical trace and coaching lesson in the dedicated PAUL database.</p>
      </div>
      <div class="header-actions">
        <span class="database-pill"><i class="fa-solid fa-database"></i> paul_ai</span>
        <span class="access-pill"><i class="fa-solid fa-lock"></i> Superadmin only</span>
        <button class="ghost-button" type="button" (click)="openChat()"><i class="fa-solid fa-comments"></i> PAUL Chat</button>
        <button class="icon-button" type="button" (click)="toggleTheme()" aria-label="Toggle theme">
          <i class="fa-solid" [class.fa-sun]="isDark" [class.fa-moon]="!isDark"></i>
        </button>
      </div>
    </header>

    <div class="notice error" *ngIf="errorMessage">{{ errorMessage }}</div>

    <section class="summary-strip">
      <button type="button" [class.active]="activeView === 'runs'" (click)="setView('runs')">
        <i class="fa-solid fa-message"></i><span>Chats & Evaluations</span><small>All persisted questions and test cases</small>
      </button>
      <button type="button" [class.active]="activeView === 'lessons'" (click)="setView('lessons')">
        <i class="fa-solid fa-graduation-cap"></i><span>Lessons</span><small>Corrections awaiting decisions</small>
      </button>
      <button type="button" [class.active]="activeView === 'training'" (click)="setView('training')">
        <i class="fa-solid fa-circle-check"></i><span>Training Ready</span><small>Accepted and independently verified</small>
      </button>
      <div class="record-count"><strong>{{ totalRows | number }}</strong><span>matching records</span></div>
    </section>

    <section class="filters-card">
      <label class="search-field"><i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="searchText" (keyup.enter)="applyFilters()" placeholder="Search questions, case IDs, answers, models or coaches"></label>
      <select [(ngModel)]="sourceFilter" *ngIf="activeView === 'runs'">
        <option value="">All sources</option><option value="admin_chat">Admin chats</option><option value="evaluation">Evaluations</option>
      </select>
      <select [(ngModel)]="evaluationFilter" *ngIf="activeView === 'runs'">
        <option value="">All results</option><option value="passed">Passed</option><option value="failed">Failed</option><option value="error">Errors</option>
      </select>
      <select [(ngModel)]="statusFilter" *ngIf="activeView === 'runs'">
        <option value="">All coaching states</option><option value="open">Open</option><option value="coached">Coached</option><option value="dismissed">No correction needed</option>
      </select>
      <select [(ngModel)]="statusFilter" *ngIf="activeView === 'lessons'">
        <option value="">All lesson decisions</option><option value="captured">Captured</option><option value="accepted">Accepted</option><option value="rejected">Rejected</option><option value="retired">Retired</option>
      </select>
      <button class="primary-button" type="button" (click)="applyFilters()">Apply</button>
      <button class="ghost-button" type="button" (click)="clearFilters()">Clear</button>
    </section>

    <section class="grid-card">
      <ag-grid-angular
        class="ag-theme-ulaap"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"
      ></ag-grid-angular>
    </section>
    <p class="grid-hint"><i class="fa-solid fa-arrow-pointer"></i> Click any row—or use <strong>View details</strong>—to open the complete run on its own page.</p>
  </main>
</div>
</app-menu>
